import { makeAutoObservable, runInAction } from 'mobx'
import { item_main, ItemStore } from 'store/item/ItemStore'
import { opt } from 'store/opt'
import { getBestMatch, SizesResponse } from 'type/size'
import { notNil } from 'util/null'

type Size2 = {
  all: boolean
  size: string | undefined
  id: string
}

function parseSize(it: string): Size2 | undefined {
  const [a, b] = it.toLowerCase().split(':')
  if (!a) return undefined
  if (!b) return { all: true, size: undefined, id: a }
  return { all: false, size: a, id: b }
}

function normalizeSize(size: string): string {
  size = size.toLowerCase()
  const match = /^(\d+)x([sml])$/i.exec(size)
  if (!match) return size
  const [, count, suffix] = match
  return 'x'.repeat(Number(count)) + suffix
}

function mathSize(size: Size2, sz: string) {
  if (!size.size) return false
  return normalizeSize(size.size) === normalizeSize(sz)
}

export class BasicStore {
  size: string | undefined

  constructor() {
    makeAutoObservable(this)
  }

  get item(): ItemStore | undefined {
    return item_main.optional
  }

  get size_id(): string | undefined {
    const sz = this.size?.toLowerCase() || undefined
    const sizes_text = this.item?.json.dress_sizes || ''
    const sizes = sizes_text.split(',').map(it => parseSize(it)).filter(notNil)
    const size = sizes.find(size => sz && mathSize(size, sz)) ?? sizes.find(size => size.all)
    return size ? size.id : undefined
  }

  get cart_link(): string | undefined {
    const id = this.size_id
    if (!id) return undefined
    return buildUtmLink(`https://brand-shop.t2.ru/cart?addToCart=${id}`)
  }

  get item_link(): string | undefined {
    return buildUtmLink(this.item?.json.links)
  }

  async init(promise: Promise<SizesResponse | undefined>) {
    this.size = undefined
    const response = await promise
    if (!response) return
    const best = getBestMatch(response)
    const name = best?.tg ?? best?.size
    runInAction(() => {
      this.size = name?.toString() || undefined
    })
  }
}

function buildUtmLink(link: string | null | undefined): string | undefined {
  if (!link) return undefined
  try {
    const url = new URL(link)
    const utm = new URLSearchParams(opt.utm_buy)
    for (const [name, value] of utm) {
      url.searchParams.append(name, value)
    }
    return url.toString()
  } catch (e) {
    console.error(e)
    return link
  }
}
